<section class="jumbotron">
  <div class="container position-relative">
    <div class="jumbotron-content text-white text-center">
      <h1 class="font-weight-bolder text-title-header">{{'header.blog' | translate}}</h1>
    </div>
  </div>
</section>
<section class="bg-white">
  <div class="container py-4 text-center">
    <h1 class="text-blue-qaira font-weight-bolder">{{'blog.title' | translate}}</h1>
    <p class="p-subtitle">{{'blog.text' | translate}}</p>
  </div>
</section>


<section>
  <div class="accordion">
    <div>
      <input type="radio" name="reports_acordeon" id="three" class="accordion__input">
      <label for="three" class="accordion__label">Nuestros artículos</label>
      <div class="accordion__content">
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_16' | translate}}</p>
          <button (click)="openModal('../../../assets/Reports/Reporte Anual 2023.pdf')"
            class="btn custom-cta border-btn col-lg-2">
            {{'blog.report_download' | translate}}
          </button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_15' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/reporte-de-sostenibilidad-qAIRa-2022.pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_13' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/Reporte-anual-de-calidad-del-aire-2022.pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_14' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/articulo-calidad-del-aire-en-la-mineria.pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_11' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/articulo-calidad-del-aire-en-interiores.pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_12' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/Reportede-exposicion-a-PM25-y-su-impacto-en-la-salud-y-economia.pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
      </div>
    </div>
    <div>
      <input type="radio" name="reports_acordeon" id="one" class="accordion__input">
      <label for="one" class="accordion__label">Lima Metropolitana</label>
      <div class="accordion__content">
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_10' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/nuevo-san-juan-marzo2022.pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_9' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/Brochure Informe ventanilla.pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_8' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/Ranking Ozono Lima Sur.pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_2' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/Boletín mensual de calidad del aire en Lima Metropolitana - Noviembre 2020.pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_1' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/Boletín mensual de calidad del aire en Lima Metropolitana - Diciembre 2020.pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
      </div>
    </div>
    <div>
      <input type="radio" name="reports_acordeon" id="two" class="accordion__input">
      <label for="two" class="accordion__label">Impacto del COVID 2019</label>
      <div class="accordion__content">
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_3' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/Primer Informe - Impacto del COVID19 en Calidad del Aire (2020).pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_4' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/Segundo Informe - Impacto del COVID19 en Calidad del Aire (2020).pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_5' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/Tercer Informe - Impacto del COVID19 en Calidad del Aire (2020).pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_6' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/Cuarto Informe - Impacto del COVID19 en Calidad del Aire (2020).pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
        <div class="report__list row">
          <p class="report__title col-lg-10">{{'blog.report_7' | translate}}</p>
          <button class="btn custom-cta border-btn col-lg-2"
            (click)="openModal('../../../assets/Reports/Quinto Informe - Impacto del COVID19 en Calidad del Aire (2020).pdf')">{{'blog.report_download'
            | translate}}</button>
        </div>
      </div>
    </div>

  </div>

</section>

<section>

  <!-- <div class="row px-0 mx-0">
    <div class="col-lg-2">
      <img width="100%" src="../../../assets/img/logo/logo-qAIRa-sin-fondo.png" alt="">
    </div>
    <div class="col-lg-8  px-3 text-center">
      <h2 class="text-green-qaira">{{'blog.report_1' | translate}}</h2>
      <div class="d-flex">
      </div>
    </div>
    <div class="col-lg-2 px-3 py-4">
      <a class="btn custom-cta border-btn mr-2" href="../../../assets/Reports/Boletín mensual de calidad del aire en Lima Metropolitana - Diciembre 2020.pdf" target="_blank">{{'blog.report_download' | translate}}</a>
    </div>
  </div>

  <div class="bg-white" style="height: 2rem;"></div>

  <div class="row px-0 mx-0">
    <div class="col-lg-2">
      <img width="100%" src="../../../assets/img/logo/logo-qAIRa-sin-fondo.png" alt="">
    </div>
    <div class="col-lg-8  px-3 text-center">
      <h2 class="text-green-qaira">{{'blog.report_2' | translate}}</h2>
      <div class="d-flex">
      </div>
    </div>
    <div class="col-lg-2 px-3 py-4">
      <a class="btn custom-cta border-btn mr-2" href="../../../assets/Reports/Boletín mensual de calidad del aire en Lima Metropolitana - Noviembre 2020.pdf" target="_blank">{{'blog.report_download' | translate}}</a>
    </div>
  </div>

  <div class="bg-white" style="height: 2rem;"></div>

  <div class="row px-0 mx-0">
    <div class="col-lg-2">
      <img width="100%" src="../../../assets/img/logo/logo-qAIRa-sin-fondo.png" alt="">
    </div>
    <div class="col-lg-8  px-3 text-center">
      <h2 class="text-green-qaira">{{'blog.report_3' | translate}}</h2>
      <div class="d-flex">
      </div>
    </div>
    <div class="col-lg-2 px-3 py-4">
      <a class="btn custom-cta border-btn mr-2" href="../../../assets/Reports/Primer Informe - Impacto del COVID19 en Calidad del Aire (2020).pdf" target="_blank">{{'blog.report_download' | translate}}</a>
    </div>
  </div>

  <div class="bg-white" style="height: 2rem;"></div>

  <div class="row px-0 mx-0">
    <div class="col-lg-2">
      <img width="100%" src="../../../assets/img/logo/logo-qAIRa-sin-fondo.png" alt="">
    </div>
    <div class="col-lg-8  px-3 text-center">
      <h2 class="text-green-qaira">{{'blog.report_4' | translate}}</h2>
      <div class="d-flex">
      </div>
    </div>
    <div class="col-lg-2 px-3 py-4">
      <a class="btn custom-cta border-btn mr-2" href="../../../assets/Reports/Segundo Informe - Impacto del COVID19 en Calidad del Aire (2020).pdf" target="_blank">{{'blog.report_download' | translate}}</a>
    </div>
  </div>

  <div class="bg-white" style="height: 2rem;"></div>

  <div class="row px-0 mx-0">
    <div class="col-lg-2">
      <img width="100%" src="../../../assets/img/logo/logo-qAIRa-sin-fondo.png" alt="">
    </div>
    <div class="col-lg-8  px-3 text-center">
      <h2 class="text-green-qaira">{{'blog.report_5' | translate}}</h2>
      <div class="d-flex">
      </div>
    </div>
    <div class="col-lg-2 px-3 py-4">
      <a class="btn custom-cta border-btn mr-2" href="../../../assets/Reports/Tercer Informe - Impacto del COVID19 en Calidad del Aire (2020).pdf" target="_blank">{{'blog.report_download' | translate}}</a>
    </div>
  </div>

  <div class="bg-white" style="height: 2rem;"></div>

  <div class="row px-0 mx-0">
    <div class="col-lg-2">
      <img width="100%" src="../../../assets/img/logo/logo-qAIRa-sin-fondo.png" alt="">
    </div>
    <div class="col-lg-8  px-3 text-center">
      <h2 class="text-green-qaira">{{'blog.report_6' | translate}}</h2>
      <div class="d-flex">
      </div>
    </div>
    <div class="col-lg-2 px-3 py-4">
      <a class="btn custom-cta border-btn mr-2" href="../../../assets/Reports/Cuarto Informe - Impacto del COVID19 en Calidad del Aire (2020).pdf" target="_blank">{{'blog.report_download' | translate}}</a>
    </div>
  </div>

  <div class="bg-white" style="height: 2rem;"></div>

  <div class="row px-0 mx-0">
    <div class="col-lg-2">
      <img width="100%" src="../../../assets/img/logo/logo-qAIRa-sin-fondo.png" alt="">
    </div>
    <div class="col-lg-8  px-3 text-center">
      <h2 class="text-green-qaira">{{'blog.report_7' | translate}}</h2>
      <div class="d-flex">
      </div>
    </div>
    <div class="col-lg-2 px-3 py-4">
      <a class="btn custom-cta border-btn mr-2" href="../../../assets/Reports/Quinto Informe - Impacto del COVID19 en Calidad del Aire (2020).pdf" target="_blank">{{'blog.report_download' | translate}}</a>
    </div>
  </div> -->
  <!-- <div class="container py-4">
    <div class="row content-blog justify-content-center">
      <div class="col-lg-6" *ngFor="let item of listBlogs">
        <app-blog-item [blog]="item"></app-blog-item>
      </div>
    </div>
  </div> -->
</section>
<!-- Modal -->
<div class="modal-backdrop" *ngIf="showModal">
  <div class="modal-custom modal--suscripcion">
    <div class="modal--suscripcion__title">¡Descarga gratuita disponible!</div>
    <div class="modal--suscripcion__subtitle">Registra tus datos para acceder al contenido exclusivo.</div>

    <form (ngSubmit)="onSubmit()" #form="ngForm">
      <div class="modal--suscripcion-campos">
        <input type="text" [(ngModel)]="name" name="name" placeholder="Nombre completo" required #nameField="ngModel">
        <div class="error" *ngIf="nameField.invalid && nameField.touched">
          El nombre es obligatorio.
        </div>
        <input type="email" [(ngModel)]="email" name="email" placeholder="Email" required email #emailField="ngModel">
        <div class="error" *ngIf="emailField.errors && emailField.touched">
          <div *ngIf="emailField.errors['required']">El email es obligatorio.</div>
          <div *ngIf="emailField.errors['email']">Debe ser un email válido.</div>
        </div>
      </div>
      <div class="modal--suscripcion-botones">
        <button type="submit" [disabled]="form.invalid">Enviar</button>
        <button type="button" (click)="closeModal()">Cancelar</button>
      </div>
    </form>
  </div>
</div>